import { AlarmClock, ChartColumn, IndianRupee, TrendingUp, Users } from "lucide-react";
import { defineFeature } from "../types";

/**
 * Reports — revenue, receivables, sales, delivery and clients (PRD US-7.2, US-7.3).
 *
 * Every page here reads the same metric dictionary the dashboard reads, so a
 * headline on a report and a tile on the dashboard are the same call rather
 * than two implementations that agree until someone edits one of them.
 *
 * `reports/metric/:metricId` is the drill-through: the rows behind a tile, with
 * their total printed underneath. Its path is declared BEFORE `reports/:id` so
 * the static segment wins the match.
 */
export default defineFeature({
  key: "reports",
  title: "Reports",
  routes: [
    { path: "reports", lazy: () => import("./page") },
    { path: "reports/metric/:metricId", lazy: () => import("./metric") },
    { path: "reports/:id", lazy: () => import("./page") },
  ],
  nav: [
    {
      label: "Reports",
      to: "/reports/revenue",
      icon: ChartColumn,
      group: "finance",
      order: 40,
      permission: "reports:view",
      description: "Revenue, receivables, sales, delivery and clients",
    },
  ],
  commands: [
    { key: "reports.revenue", label: "Revenue report", icon: IndianRupee, to: "/reports/revenue", group: "navigate", keywords: ["billed", "collected", "turnover"] },
    { key: "reports.receivables", label: "Receivables and DSO", icon: AlarmClock, to: "/reports/receivables", group: "navigate", keywords: ["ageing", "outstanding", "overdue"] },
    { key: "reports.sales", label: "Sales and pipeline report", icon: TrendingUp, to: "/reports/sales", group: "navigate", keywords: ["win rate", "funnel", "forecast"] },
    { key: "reports.clients", label: "Client churn report", icon: Users, to: "/reports/clients", group: "navigate", keywords: ["churn", "retention", "new clients"] },
    { key: "reports.fy", label: "Reports for this financial year", icon: ChartColumn, to: "/reports/revenue?period=fy", group: "navigate", keywords: ["fy", "annual", "year"] },
  ],
});
